import { Box, Tooltip, useTheme } from '@mui/material';
import React from 'react';

import { ISettingItem } from '../../../types/oneLink';

export const SettingsItem: React.FC<ISettingItem> = ({ condition, backgroundColor, tooltipTitle, icon }) => {
  const {
    palette: { common },
  } = useTheme();

  if (!condition) {
    return null;
  }

  const settingsBoxStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: 0.5,
    border: `1px solid ${common.white}`,
  };

  return (
    <Box
      sx={{
        ...settingsBoxStyle,
        backgroundColor,
      }}
    >
      <Tooltip title={tooltipTitle} placement="top" arrow>
        {icon}
      </Tooltip>
    </Box>
  );
};
